<div class="row modal-bar">
  <div class="col-sm-9">
    <h5 class="modal-title">{{ passedData.title }}</h5>
  </div>
  <div class="col-sm-3">
    <div class="modal-actions">
      <div class="modal-close">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="dialogRef.close(false);"></button>
      </div>
    </div>
  </div>
</div>

<form [formGroup]="form" class="form-content">
  <div class="section-wrapper">
    <div class="form-layout">
      <div class="row mg-b-25">
        <div class="col-lg-6">
          <div class="form-group">
            <label class="form-control-label">
              {{ 'SALE-CATEGORIES.FORM.LABEL.NAME' | translate }}<span class="tx-danger">*</span>
            </label>
            <input class="form-control" formControlName="Name"
              placeholder="{{ 'SALE-CATEGORIES.FORM.PLACEHOLDER.NAME' | translate }}"
              maxlength="100">
              <t4-display-validation controlName="Name" [form]="form" [messages]="validationMessages"></t4-display-validation>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="form-group">
              <label class="form-control-label">
                {{ 'SALE-CATEGORIES.FORM.LABEL.CODE' | translate }}<span class="tx-danger">*</span>
              </label>
              <input class="form-control" formControlName="Code"
                placeholder="{{ 'SALE-CATEGORIES.FORM.PLACEHOLDER.CODE' | translate }}"
                maxlength="50">
                <t4-display-validation controlName="Code" [form]="form" [messages]="validationMessages"></t4-display-validation>
                @if (!isNew) {
                  <small class="form-text text-muted">
                    {{ 'SALE-CATEGORIES.FORM.HINT.CODE-NOT-EDITABLE' | translate }}
                  </small>
                }
              </div>
            </div>
          </div>

          <div class="row mg-b-25">
            <div class="col-lg-6">
              <div class="form-group">
                <label class="form-control-label">
                  {{ 'SALE-CATEGORIES.FORM.LABEL.TRANSLATION-CODE' | translate }}<span class="tx-danger">*</span>
                </label>
                <input class="form-control" formControlName="TranslationCode"
                  placeholder="{{ 'SALE-CATEGORIES.FORM.PLACEHOLDER.TRANSLATION-CODE' | translate }}"
                  maxlength="100">
                  <t4-display-validation controlName="TranslationCode" [form]="form" [messages]="validationMessages"></t4-display-validation>
                </div>
              </div>

              <div class="col-lg-6">
                <div class="form-group">
                  <label class="form-control-label">
                    {{ 'SALE-CATEGORIES.FORM.LABEL.TAB-ORDER' | translate }}<span class="tx-danger">*</span>
                  </label>
                  <input type="number" class="form-control" formControlName="TabOrder"
                    placeholder="{{ 'SALE-CATEGORIES.FORM.PLACEHOLDER.TAB-ORDER' | translate }}"
                    min="0">
                    <t4-display-validation controlName="TabOrder" [form]="form" [messages]="validationMessages"></t4-display-validation>
                  </div>
                </div>
              </div>

              <div class="row mg-b-25">
                <div class="col-lg-6">
                  <div class="form-group">
                    <mat-checkbox formControlName="Active">
                      {{ 'SALE-CATEGORIES.FORM.LABEL.ACTIVE' | translate }}
                    </mat-checkbox>
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="form-group">
                    <mat-checkbox formControlName="IsAlwaysVisibleInShop">
                      {{ 'SALE-CATEGORIES.FORM.LABEL.ALWAYS-VISIBLE-IN-SHOP' | translate }}
                    </mat-checkbox>
                  </div>
                </div>
              </div>

              @if (isReadOnly) {
                <div class="row mg-b-25">
                  <div class="col-12">
                    <div class="alert alert-info">
                      {{ 'SALE-CATEGORIES.FORM.HINT.READONLY' | translate }}
                    </div>
                  </div>
                </div>
              }

              <div class="form-layout-footer row">
                @if (!isReadOnly) {
                  <div class="col-6">
                    <button (click)="submit()" [disabled]="form.invalid" class="btn btn-block btn-primary bd-0">
                      <i class="far fa-save"></i>
                      <span>{{ 'GENERIC.BUTTON.SAVE' | translate }}</span>
                    </button>
                  </div>
                }
                <div [class.col-6]="!isReadOnly" [class.col-12]="isReadOnly">
                  <button (click)="dialogRef.close(false)" class="btn btn-block btn-secondary bd-0">
                    <i class="fas fa-ban"></i>
                    <span>{{ (isReadOnly ? 'GENERIC.BUTTON.CLOSE' : 'GENERIC.BUTTON.CANCEL') | translate }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
